import apolloClient from "../../../config/apolloClient";
import {
    createUserMutation,
    exchangeRefreshTokenMutation,
    getSubscriptionQuery,
    loginMutation,
    requestChangePasswordMutation,
    requestNewPasswordMutation,
} from "./auth.gql";

export interface ILoginPayload {
    email: string;
    password: string;
}

export interface IRegisterPayload extends ILoginPayload {
    firstname: string;
    lastname: string;
    email: string;
    password: string;
    role: string;
}

export const clearLocalStorage = () => {
    const instructionStateBakeACake = localStorage.getItem(
        "instructionStateBakeACake"
    );
    const instructionStateBuildACar = localStorage.getItem(
        "instructionStateBuildACar"
    );
    localStorage.clear();
    localStorage.setItem(
        "instructionStateBakeACake",
        instructionStateBakeACake || ""
    );
    localStorage.setItem(
        "instructionStateBuildACar",
        instructionStateBuildACar || ""
    );
};

export const loginRequest = async (payload: ILoginPayload) => {
    const { data, errors } = await apolloClient.mutate({
        mutation: loginMutation,
        variables: {
            input: {
                ...payload,
            },
        },
    });

    if (errors) {
        throw errors;
    }

    return { response: data.Login };
};

export const exchangeRefreshTokenRequest = async (refreshToken: string) => {
    const { data, errors } = await apolloClient.mutate({
        mutation: exchangeRefreshTokenMutation,
        variables: {
            input: {
                refreshToken,
            },
        },
    });

    if (errors) {
        return { errors };
    }

    if (!data.ExchangeRefreshToken) {
        return {
            errors: "Failed to exchange token.",
        };
    }

    return { response: data.ExchangeRefreshToken };
};

export const registerRequest = async (payload: IRegisterPayload) => {
    const { data, errors } = await apolloClient.mutate({
        mutation: createUserMutation,
        variables: {
            createUserInput: {
                ...payload,
            },
        },
    });

    if (errors) {
        throw errors;
    }

    return data.Register;
};

export const changePasswordRequest = async (payload: { email: string }) => {
    const { data, errors } = await apolloClient.mutate({
        mutation: requestChangePasswordMutation,
        variables: {
            input: {
                ...payload,
            },
        },
    });

    if (errors) {
        throw errors;
    }

    return { response: data };
};

export const updatePasswordRequest = async (payload: {
    token: string;
    password: string;
}) => {
    const { data, errors } = await apolloClient.mutate({
        mutation: requestNewPasswordMutation,
        variables: {
            input: {
                ...payload,
            },
        },
    });

    if (errors) {
        throw errors;
    }

    return { response: data };
};

export const getValidToken = async (operationName = "") => {
    let token = JSON.parse(localStorage.getItem("token") || "{}");

    if (token) {
        if (token.access_token && operationName !== "ExchangeRefreshToken") {
            const access_token = token.access_token.split(".");

            const access_token_exp = JSON.parse(
                atob(access_token[1]) as any
            ).exp;

            if (Date.now() >= access_token_exp * 1000) {
                console.log("Token expired !!!");
                const { response, errors } = await exchangeRefreshTokenRequest(
                    token.refresh_token
                );

                if (errors) {
                    localStorage.clear();
                    window.location.reload();
                }

                token = {
                    access_token: response.access_token,
                    refresh_token: response.refresh_token,
                };

                localStorage.setItem("token", JSON.stringify(token));

                localStorage.setItem(
                    "user",
                    JSON.stringify({
                        ...response.user,
                    })
                );
            }
        }
    }

    return token;
};

export const getSubscription = async () => {
    const { data, errors } = await apolloClient.query({
        query: getSubscriptionQuery,
    });

    if (errors) {
        return { errors };
    }

    return { response: data.getSubscription };
};
